module.exports = __webpack_public_path__ + "img/img-1.16c68759.png";